import { atom } from 'jotai';

export const mapInstants = atom(null);
export const centerObj = atom(null);
